import React from 'react';
import s from './faq.module.scss';
import locales from '../../../content.json';

export const Faq = ({ theme1 }: { theme1?: boolean }) => {
  const [activeIndexes, setActiveIndexes] = React.useState([0]);
  const faqData = [
    {
      question: locales[window.userLang].payment_text_202,
      answer: locales[window.userLang].payment_text_203,
    },
    {
      question: locales[window.userLang].payment_text_204,
      answer: locales[window.userLang].payment_text_205,
    },
    {
      question: locales[window.userLang].payment_text_206,
      answer: locales[window.userLang].payment_text_207,
    },
  ];
  return (
    <div className={`${s.faqWrapper} ${theme1 ? s.theme1 : ''}`}>
      <p className={s.faqTitle}>{locales[window.userLang].payment_text_201}</p>
      <div className={s.faqItems}>
        {faqData.map((item, idx) => (
          <div
            key={idx}
            className={activeIndexes.includes(idx) ? `${s.faqItem} ${s.active}` : s.faqItem}
          >
            <p
              className={s.faqItemQuestion}
              onClick={() => setActiveIndexes(
                activeIndexes.includes(idx)
                  ? activeIndexes.filter(i => i !== idx)
                  : [...activeIndexes, idx]
              )}
            >
              {item.question}
            </p>
            <p className={s.faqItemAnswer}>{item.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};